import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Renders an array of strings as line-by-line masked reveal.
export default function AnimatedHeadline({ lines, className = "", lineClassName = "", delay = 0.1 }) {
  return (
    <h1 className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-line" aria-hidden="true">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.05, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}
